export default __webpack_public_path__ + "117414c0791e4a70a29db73812d09a3a.svg";